// useDashboardData.js
import { useEffect, useState } from "react";
import axios from "axios";
import sampleData from "./prodSampleData";

/**
 * useDashboardData
 * - tries to fetch from /api/dashboard (example)
 * - falls back to sampleData after a short timeout or on error
 *
 * Adjust the API endpoint to match your backend.
 */
export default function useProdDashboardData() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      // try {
      //   // change /api/dashboard to your real endpoint
      //   const res = await axios.get("/api/dashboard", { timeout: 4000 });
      //   if (mounted && res?.data) {
      //     setData(res.data);
      //     setLoading(false);
      //     return;
      //   }
      // } catch (err) {
      //   // swallow - we'll fallback to sample data
      //   console.warn("Dashboard fetch failed, using sample data.", err?.message || err);
      // }

      // // fallback to sample data (simulate small delay so UI shows loader)
      setTimeout(() => {
        if (!mounted) return;
        setData(sampleData);
        setLoading(false);
      }, 300);

      
    };

    fetchData();

    return () => {
      mounted = false;
    };
  }, []);

  return { data, loading, error };
}
